import React from 'react';
import { ClearComponent } from '../shared';

const ClearPage = () => {
  return <ClearComponent />;
};

export default ClearPage;
